import { api } from "./api.js";

/**
 * Crea un reporte y sube sus fotos de forma secuencial. `estado` se conserva
 * entre reintentos: si una subida falla, no vuelve a crear el reporte ni repite
 * las fotos que ya llegaron al servidor.
 */
async function publicarReporte({ recurso, payload, fotos, estado, onProgreso, tokenAntiBot }) {
  let { reporte } = estado;
  if (!reporte) {
    // El token anti-bot solo hace falta al crear: subir fotos ya exige el
    // codigo de gestion, que es una credencial real. Si el reporte ya existe
    // (reintento tras fallo de subida) no se vuelve a pedir token.
    reporte = await recurso.crear(payload, tokenAntiBot);
    estado.reporte = reporte;
    estado.multimedia = [];
  }

  const inicio = estado.multimedia.length;
  for (const [indice, foto] of fotos.entries()) {
    if (indice < inicio) continue;
    onProgreso({ indice: indice + 1, total: fotos.length, porcentaje: 0 });
    try {
      const multimedia = await recurso.subirFoto(
        reporte.id,
        reporte.codigoGestion,
        foto.archivo,
        {
          onProgreso: (porcentaje) =>
            onProgreso({ indice: indice + 1, total: fotos.length, porcentaje }),
        },
      );
      estado.multimedia.push(multimedia);
    } catch (error) {
      throw new Error(
        `${foto.archivo.name || `Foto ${indice + 1}`}: ${error.message} Pulsa “Publicar reporte” para reanudar desde esta foto.`,
      );
    }
  }

  return { ...reporte, multimedia: estado.multimedia };
}

export function publicarMascota(opciones) {
  return publicarReporte({ ...opciones, recurso: api.mascotas });
}

export function publicarPersona(opciones) {
  return publicarReporte({ ...opciones, recurso: api.personas });
}
